// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, string, func } from 'prop-types'

import {
  Button,
  CardBody,
  Card,
  Collapse,
} from 'reactstrap'

const InfoGroup = ({ heading, items, assignActiveInfoGroup, activeInfoGroup }) => (
  <section>
    <h2>{heading}</h2>
    {items.map((d, i) => (
      <div
        key={i}
        className={'faq-collapse'}>
        <Button
          id={`${heading}-${i}`}
          className='faq-question'
          onClick={() => assignActiveInfoGroup(d.label)}>
          {d.label}
        </Button>
        <Collapse
          isOpen={d.label === activeInfoGroup}
          className='faq-answer'>
          <Card>
            <CardBody>
              {d.details}
            </CardBody>
          </Card>
        </Collapse>
      </div>

    ))}
  </section>
)

InfoGroup.propTypes = {
  heading: string.isRequired,
  items: array.isRequired,
  assignActiveInfoGroup: func.isRequired,
  activeInfoGroup: string,
}

export default InfoGroup
